import axios from 'axios';
import {getFriendMessagesRoute, sendMessageRoute} from "../../utils/apiRoutes";
import {GET_ALL_MESSAGES, SEND_MESSAGE, SET_ARRIVAL_MESSAGE} from './typesAction';
import {setAlert} from "./alertAction";

export const getFriendMessages = (receiver) => async (dispatch) => {
    try {
        const res = await axios.get(getFriendMessagesRoute + "/" + receiver);

        dispatch({
            type: GET_ALL_MESSAGES,
            payload: res.data,
        });
    } catch (err) {
        const errors = err.response.data.errors;

        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
        }
    }
};

export const sendMessage = (message, receiver, isGroup = false) => async (dispatch) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const body = JSON.stringify({receiver, message, isGroup});

    try {
        const res = await axios.post(sendMessageRoute, body, config);

        if (!isGroup) {
            dispatch({
                type: SEND_MESSAGE,
                payload: res.data,
            });
        }

    } catch (err) {
        const errors = err.response.data.errors;

        if (errors) {
            errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
        }
    }
};

export const setArrivalMessage = (message) => (dispatch) => {
    dispatch({
        type: SET_ARRIVAL_MESSAGE,
        payload: message,
    });
};